<template functional>
    <svg
        :width="props.size"
        :height="props.size"
        viewBox="0 0 24 24"
        :fill="props.colorFill"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="##D6001B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: "IconRedDot",
    props: {
        size: { type: [String, Number], default: "16px" },
        colorFill: { type: String, default: "#d6001b" },
    },
};
</script>
